import { ReactNode } from 'react';
import classNames from 'classnames';
import { DiscordLogo } from 'images/svg';
import { useTranslation } from 'next-i18next';
import { getDashboardUrl } from 'services/EnvProvider';

interface ISupportDiscord {
  header: string;
  description?: string;
  children?: ReactNode;
  className?: string;
}

const SupportDiscord = (props: ISupportDiscord) => {
  const { header, description, children, className } = props;

  const { t } = useTranslation();

  const classes = classNames('support-discord', className);

  const dashboardUrl = getDashboardUrl();

  return (
    <div className={classes}>
      <div>
        <DiscordLogo />
        <h3 className="support-discord__header header">{header}</h3>
        {description && (
          <p className="support-discord__header-description header__description">
            {description}
          </p>
        )}
        <a
          href={`${dashboardUrl}/discord`}
          className="support-discord__btn btn btn-type-blue"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('page.discordLink')}
        </a>
      </div>
      <>{children}</>
    </div>
  );
};

export default SupportDiscord;
